import React, { useEffect, useState } from "react";
import PageTitle from "../PageTitle";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getBlogById } from "../../store/blogSlice";

function BlogDetails() {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchHackathon = async () => {
      const result = await dispatch(getBlogById(id)).unwrap();
      setBlog(result);
    };
    fetchHackathon();
  }, [dispatch, id]);

  if (!blog) return <p className="mt-32 text-center">Loading...</p>;

  return (
    <div className="mt-32 max-w-4xl mx-auto bg-white shadow-xl rounded-2xl p-10 border border-gray-100">
      <PageTitle title={`${blog.Title} - Blogs | JobIntelPro`} />

      {/* Title & Organizer */}
      <div className="text-center mb-8">
        <h1 className="text-3xl font-extrabold text-indigo-700">
          {blog.Title}
        </h1>
      </div>

      {/* Description (left aligned) */}
      <div className="prose max-w-none mt-6 text-gray-700 text-left">
        <div dangerouslySetInnerHTML={{ __html: blog.Description }} />
      </div>
    </div>
  );
}

export default BlogDetails;
